import { Chip, Stack } from '@mui/material'
import get from 'lodash/get'
import { useLocaleState, useTranslate } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { ChipGroupStatusProps } from './type'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

export const ChipGroupStatus: React.FC<ChipGroupStatusProps> = ({
  record,
  publishedSource = 'is_published',
  approvedSource = 'is_approved',
  highlightSource =  'is_highlight',
  // approvedSource = 'is_approved',
  expiredSource = 'end_date',
  activedSource = 'is_active',
  stackProps = {},
}) => {
  const translate = useTranslate()
  const [locale] = useLocaleState()
  const publishField = get(record, publishedSource)
  const approveField = get(record, approvedSource)
  const highlightField = get(record, highlightSource)
  const expireField = get(record, expiredSource)
  const activedField = get(record, activedSource)
  const isActive = activedField ? 'active' : 'inActive'
  let activeChip = null
  let expireChip = null
  let approveChip = null 
  let highlightChip = null 
  let publishChip = null
  if (expireField && publishField) {
    const isExpired = !dayjs(expireField).isAfter(dayjs())
    expireChip = (
      <Chip
        color={isExpired ? 'warning' : 'info'}
        label={`${translate(`${COMMON_FIELDS}.expired.label`)} ${dayjs(expireField)
          .locale(locale)
          .fromNow()}`}
        size='small'
      />
    )
  }
  if (approveField) {
    approveChip = (
      <Chip
        color={approveField ? 'success' : 'error'}
        label={translate(`${COMMON_FIELDS}.approved.choices.${approveField}`)}
        size='small'
      />
    )
  }
  if (highlightField) {
    highlightChip = (
      <Chip
        color={highlightField ? 'primary' : 'secondary'}
        label={translate(`${COMMON_FIELDS}.highlight.choices.${highlightField}`)}
        size='small'
      />
    )
  }
  if (activedField != null) {
    activeChip = (
      <Chip
        color={activedField ? 'success' : 'error'}
        label={translate(`${COMMON_FIELDS}.status.choices.${isActive}`)}
        size='small'
      />
    )
  }
    
  if (publishField != null) 
    publishChip = (
      <Chip
        color={publishField ? 'success' : 'error'}
        label={translate(`${COMMON_FIELDS}.published.choices.${publishField}`)}
        variant='filled'
        size='small'
      />
    )
  if (highlightField != null) {
    highlightChip = (
      <Chip
        color={highlightField ? 'primary' : 'secondary'}
        label={translate(`${COMMON_FIELDS}.highlight.choices.${highlightField}`)}
        size='small'
      />
    )
  }
  return (
    <Stack spacing={1} direction='column' alignItems='flex-end' flexGrow='0' {...stackProps}>
      {expireChip}
      {publishChip}
      {activeChip}
      {highlightChip}
      {approveChip}
      {highlightChip}
    </Stack>
  )
}
